import React from 'react';
import { useState } from "react";
import { database } from '../../firebaseConfig'
import { collection, addDoc, deleteDoc, doc } from "firebase/firestore";
import AdminDashboard from '../../UserPanel/Shared/AdminDashboard/AdminDashboard';
import "./ManageTeam.css"
const ManageTeam = (props) => {
    const collectionRef = collection(database, "team");

    const [image, setImage] = useState('');
    const [data, setData] = useState({});


    const handleInput = (event) => {
        let newInput = { [event.target.name]: event.target.value };
        setData({ ...data, ...newInput });
    };



    const handleSubmit = () => {
        if (image) {
            addDoc(collectionRef, {
                img: image,
                name: data.name,
                serial: data.serial,
                study: data.study || null,
                designation: data.designation,
                membership: data.membership || null

            }).then(() => {
                document.getElementById('image').value = '';
                document.getElementById('name').value = '';
                document.getElementById('serial').value = '';
                document.getElementById('study').value = '';
                document.getElementById('designation').value = '';
                document.getElementById('membership').value = '';
                alert('image is uploaded')
            }).catch((error) => {
                alert(error.message);
                document.getElementById('image').value = '';
                document.getElementById('name').value = '';
                document.getElementById('serial').value = '';
                document.getElementById('study').value = '';
                document.getElementById('designation').value = '';
                document.getElementById('membership').value = '';
            })
        }
        else {
            alert("no Image Found")
        }


    }

    const handleDelete = (id) => {

        deleteDoc(doc(database, "team", id)).then(() => {
            alert("image deleted")
        })


    }





    const convert2base64 = e => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setImage(reader.result.toString());
        }
        reader.readAsDataURL(file);
    }

    return (
        <div className='teamBack' >
            <AdminDashboard></AdminDashboard>
            <div className='container  '>
                <div className="row justify-content-md-center d-flex">
                    <div className="submitBox mt-5">
                        <input
                            id="name"
                            name="name"
                            placeholder="Name"
                            onChange={(event) => handleInput(event)} /><br />
                        <input
                            id="designation"
                            name="designation"
                            placeholder="Designation"
                            onChange={(event) => handleInput(event)} /><br />
                        <input
                            id="study"
                            name="study"
                            placeholder="Study"
                            onChange={(event) => handleInput(event)} /><br />

                        <input
                            id="membership"
                            name="membership"
                            placeholder="Membership"
                            onChange={(event) => handleInput(event)} /><br />
                        <input
                            id="serial"
                            name="serial"
                            placeholder="Serial"
                            onChange={(event) => handleInput(event)} /><br />

                        <br />
                        <input id="image" type="file" style={{ "marginTop": "27px" }} onChange={e => convert2base64(e)} />
                        <button className='btn btn-success' onClick={handleSubmit}>Submit</button>
                    </div>

                    <table className='tableBox'>
                        <tr className='projectBox'>
                            <th>Serial</th>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Study</th>
                            <th>Membership</th>
                            <th>Button</th>


                        </tr>
                        {props.team.sort((a, b) => a.serial - b.serial).map((item) => {
                            return (
                                <tr key={item.id} className='projectBox'>
                                    <td>{item.serial}</td>
                                    <td><img src={item.img} height="80px" width="80px" style={{ borderRadius: "50%" }} alt="" /></td>
                                    <td>{item.name}</td>
                                    <td>{item.designation}</td>
                                    <td>{item.study}</td>
                                    <td>{item.membership}</td>


                                    <td>  <button className='btn btn-danger m-2' onClick={() =>
                                        handleDelete(item.id)} >Delete</button></td>

                                </tr>
                            )
                        })}
                    </table>
                </div>
            </div>
        </div>

    );
}

export default ManageTeam;
